export default __webpack_public_path__ + "static/kabir-ce51c6130ac352765758c0f648d7d1fd.png";